import React from 'react';
import PropTypes from 'prop-types';

const CardMedia = ({ children, style }) => {
  return (
    <div style={style} className="uni-card__media">
      {children}
    </div>
  );
};

CardMedia.propTypes = {
  children: PropTypes.node,
  style: PropTypes.object,
};

export default CardMedia;



// WEBPACK FOOTER //
// ./src/card/card-media/index.jsx